export const PRIZE_STATUS = {
  set_up: 'set_up',
  live: 'live',
  pick_winners: 'pick_winners',
  picked_winners: 'picked_winners',
};

export const CANCEL_STATUSES = [
  PRIZE_STATUS.live,
  PRIZE_STATUS.pick_winners,
  PRIZE_STATUS.picked_winners,
];
